__turbopack_context__.v({
  "inputVolumeRange": "volume-module__DIDm1q__inputVolumeRange",
  "volumeContainer": "volume-module__DIDm1q__volumeContainer",
  "volumeSubContainer": "volume-module__DIDm1q__volumeSubContainer",
});
